import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Clear from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";

const mergeAdornments = (...adornments) => {
  const nonNullAdornments = adornments.filter((el) => el != null);
  if (nonNullAdornments.length === 0) {
    return null;
  }

  if (nonNullAdornments.length === 1) {
    return nonNullAdornments[0];
  }

  return (
    <Stack direction="row">
      {nonNullAdornments.map((adornment, index) => (
        <React.Fragment key={index}>{adornment}</React.Fragment>
      ))}
    </Stack>
  );
};

const PickerTextField = ({ onClearClick, ...rest }) => (
  <TextField
    {...rest}
    InputProps={{
      ...rest.InputProps,
      endAdornment: mergeAdornments(
        <InputAdornment position="end">
          <IconButton onClick={onClearClick}>
            <Clear />
          </IconButton>
        </InputAdornment>,
        rest.InputProps?.endAdornment ?? null
      ),
    }}
  />
);

export default function DateWithClear(props) {
  const handleClear = () => {
    props.onChange(null);
  };

  return (
    <>
      <DatePicker
        {...props}
        value={props.value}
        slotProps={{
          textField: {
            onClearClick: handleClear,
            size: "small",
            fullWidth: true,
            margin: "dense",
            error: false,
          },
          popper: {
            style: { zIndex: 300000 },
          },
        }}
        slots={{
          textField: PickerTextField,
        }}
        format="YYYY-MM-DD"
      />
    </>
  );
}
